/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Panel_SubtitleInputs */

const en_chat_panel_subtitle = /** @type {(inputs: Chat_Panel_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispatch tasks in natural language`)
};

const fr_chat_panel_subtitle = /** @type {(inputs: Chat_Panel_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispatch des tâches en langage naturel`)
};

const ms_sg2_chat_panel_subtitle = /** @type {(inputs: Chat_Panel_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancar tugasan dalam bahasa harian`)
};

/**
* | output |
* | --- |
* | "Dispatch tasks in natural language" |
*
* @param {Chat_Panel_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_panel_subtitle = /** @type {((inputs?: Chat_Panel_SubtitleInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Panel_SubtitleInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_panel_subtitle(inputs)
	if (locale === "fr") return fr_chat_panel_subtitle(inputs)
	return ms_sg2_chat_panel_subtitle(inputs)
});